import { forwardRef } from 'react';
import { Box as MUIBox, BoxProps as MUIBoxProps } from '@mui/material';

export interface IBoxProps extends MUIBoxProps {}

const Box = forwardRef<unknown, IBoxProps>((props, ref) => {
  const { children, ...restProps } = props;
  return <MUIBox {...restProps} ref={ref}>{children}</MUIBox>;
});

export default Box;
